import {
  PAGE_DETAIL_FETCH,
  PAGE_DETAIL_SUCCESS,
  PAGE_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const pageDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case PAGE_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case PAGE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/PageDetail/reducer.js